import React from "react";
import Navigation from "../components/Navigation";

const AnalizeScreenLoggedIn = () => {
  // Mock stats
  const stats = {
    totalValue: "$12,450.67",
    totalReturn: "+$1,234.56",
    returnPercent: "+11.02%",
    bestPerformer: "MSFT (+15.67%)",
    worstPerformer: "TSLA (-3.45%)",
  };

  return (
    <div className="screen">
      <Navigation />
      <div className="screen-header" style={{ marginTop: 56 }}>
        <h1 className="screen-title">Portfolio Analysis</h1>
        <p className="screen-subtitle">
          Deep insights into your investment performance
        </p>
      </div>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Summary</h3>
        </div>
        <div className="grid-3">
          <div className="portfolio-card">
            <div className="portfolio-value">{stats.totalValue}</div>
            <div className="portfolio-label">Total Value</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value" style={{ color: "#22C55E" }}>
              {stats.totalReturn}
            </div>
            <div className="portfolio-label">Total Return</div>
          </div>
          <div className="portfolio-card">
            <div className="portfolio-value" style={{ color: "#22C55E" }}>
              {stats.returnPercent}
            </div>
            <div className="portfolio-label">Return %</div>
          </div>
        </div>
      </div>
      {/* Add more sections: charts, allocation, top performers, etc. */}
    </div>
  );
};

export default AnalizeScreenLoggedIn;
